import { observable, action, makeObservable, set } from 'mobx';

import { ReceiptOfProductType } from '../../shared/support/modelTypes';

export interface ReceiptOfProductFormStoreType {
	model: ReceiptOfProductType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude: Array<any>;
	selectedItems: Array<any>;
	requiredToFill: Array<{ predefinedName: string; property: string; relation: string }>;
	isFirstLoad: boolean;
	name: string;
	isSequenceNumberChangedManually: boolean;
	searchText: string;
	setValue(model: any, key: string, value: any): void;
}

class ReceiptOfProductFormStore implements ReceiptOfProductFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			filterInclude: observable,
			selectedItems: observable,
			requiredToFill: observable,
			isFirstLoad: observable,
			name: observable,
			isSequenceNumberChangedManually: observable,
			searchText: observable,
			setValue: action
		});
	}

	model = {
		amount: 0,
		deleted: false,
		note: null,
		organizationId: null,
		ownerId: null,
		ownerType: null,
		posted: false,
		priceTypeId: null,
		responsibleId: null,
		warehouseId: null,
		periodAt: null,
		authorId: null,
		partnerId: null,
		contractId: null,
		incomeDocDate: new Date(),
		incomeDocNumber: '',
		partnerBankAccountId: null,
		consignorId: null,
		consigneeId: null,
		productItemList: [],
		productItems: [],
		prepayItems: [],
		prepayItemList: []
	};
	searchText = '';
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	isSequenceNumberChangedManually = false;
	pluralName = 'receiptOfProducts';
	filterInclude = [
		'organization',
		'priceType',
		'warehouse',
		'partner',
		'contract',
		'partnerBankAccount',
		'consignor',
		'consignee',
		'prepayItems',
		{
			relation: 'productItems',
			scope: {
				include: ['unit', 'feature', 'serialNumber', 'product']
			}
		}
	];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	requiredToFill = [
		{
			predefinedName: 'DefaultOrganization',
			property: 'organizationId',
			relation: 'organization'
		},
		{
			predefinedName: 'DefaultPriceType',
			property: 'priceTypeId',
			relation: 'priceType'
		},
		{
			predefinedName: 'DefaultWarehouse',
			property: 'warehouseId',
			relation: 'warehouse'
		}
	];
	isFirstLoad = true;
	name = 'OrmReceiptOfProducts';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const receiptOfProductFormStore = new ReceiptOfProductFormStore();

export default ReceiptOfProductFormStore;
